import React from 'react';
import DynamicCollectionCard from '../components/dynamic/DynamicCollectionCard';

interface DynamicTabContentCardProps {
    dynamicCollections: any[];
    tabName: string;
}

const DynamicTabContentCard: React.FC<DynamicTabContentCardProps> = ({
                                                                         dynamicCollections,
                                                                         tabName,
                                                                     }) => {
    const collectionsForTab = dynamicCollections.filter(item => item.tab_name === tabName);

    return (
        <>
            {collectionsForTab.map((collection) => (
                <DynamicCollectionCard
                    key={collection.collection_name}
                    collectionName={collection.collection_name}
                    header={`${collection.collection_name} Details`}
                    eventGroupToTrigger={tabName}
                />
            ))}
        </>
    );
};

export default React.memo(DynamicTabContentCard);
